var map = {
	"./proyectos/antioquia/ficha.png": 5363,
	"./proyectos/antioquia/ficha1.png": 721,
	"./proyectos/argos/ficha.png": 3492,
	"./proyectos/argos/ficha_mineria.png": 7301,
	"./proyectos/argos/gtm/ficha.png": 9257,
	"./proyectos/argos/gtm/ficha1.png": 1346,
	"./proyectos/argos/mineria/ficha.png": 1518,
	"./proyectos/cundinamarca/ficha.png": 376,
	"./proyectos/cundinamarca/ficha1.png": 6569,
	"./proyectos/cundinamarca/ficha2.png": 8296,
	"./proyectos/ecopetrol/mapexplorer/Mapexplorer.png": 1775,
	"./proyectos/ecopetrol/mapexplorer/ficha.png": 1572,
	"./proyectos/ecopetrol/sig/ficha.png": 2078,
	"./proyectos/ecopetrol/siginmo/ficha.png": 1011,
	"./proyectos/ecopetrol/siginmo/ficha1.png": 8235,
	"./proyectos/ecopetrol/sigvep/ficha.png": 720,
	"./proyectos/ecopetrol/sigvep/ficha1.png": 5423,
	"./proyectos/ecopetrol/sigvep/ficha3.png": 613,
	"./proyectos/ingeominas/ficha.png": 7653,
	"./proyectos/ingeominas/saac/ficha.png": 7478,
	"./proyectos/ingeominas/saac/ficha1.png": 3172,
	"./proyectos/ingeominas/siger/Sin título.png": 1976,
	"./proyectos/ingeominas/siger/Sin título2.png": 5293,
	"./proyectos/ingeominas/siger/Sin título4.png": 163,
	"./proyectos/ingeominas/siger/ficha.png": 7926,
	"./proyectos/ingeominas/siger/ficha3.png": 6754,
	"./proyectos/ingeominas/siger/geologia.png": 2810,
	"./proyectos/ingeominas/siger/geologia2.png": 4278,
	"./proyectos/ingeominas/visorweb/ficha.png": 54,
	"./proyectos/minenergia/ficha.png": 9177,
	"./proyectos/minercol/rmn/ficha.png": 5746,
	"./proyectos/upme/portalmapas/Ficha2.png": 9880,
	"./proyectos/upme/portalmapas/ficha.png": 6327,
	"./proyectos/upme/portalmapas/ficha1.png": 6344,
	"./proyectos/upme/portalmapas/transparencia.png": 3581,
	"./proyectos/upme/sige/ficha.png": 1556,
	"./proyectos/upme/sige/sige1.png": 6502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;